import { useCallback, useState } from 'react'

import { Alert, Box, Tab, Tabs, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

import FeatureFlagsForm from '../components/settings/FeatureFlagsForm'
import OpenAIConnectionTest from '../components/settings/OpenAIConnectionTest'
import SettingsForm from '../components/settings/SettingsForm'

export default function SettingsPage() {
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get('tab') === 'features' ? 1 : 0

  const handleSave = useCallback(() => {
    setError('')
    setSuccess('Settings saved successfully!')
    setTimeout(() => setSuccess(''), 3000)
  }, [])

  const handleError = useCallback((errorMessage: string) => {
    setSuccess('')
    setError(errorMessage)
  }, [])

  return (
    <Box sx={{ flex: 1, p: { xs: 2.5, sm: 3 } }}>
      <Typography variant="h4" component="h1" gutterBottom>Settings</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Manage app settings and feature rollouts.</Typography>

      <Tabs
        value={activeTab} aria-label="Settings sections" sx={{ mb: 3, borderBottom: '1px solid', borderColor: 'divider' }}
        onChange={(_event, value: number) => {
          const next = new URLSearchParams(searchParams)
          if (value === 1) next.set('tab', 'features')
          else next.delete('tab')
          setSearchParams(next, { replace: true })
        }}
      >
        <Tab label="App settings" id="app-settings-tab" aria-controls="app-settings-panel" sx={{ textTransform: 'none', px: 0, mr: 4 }} />
        <Tab label="Feature flags" id="feature-flags-tab" aria-controls="feature-flags-panel" sx={{ textTransform: 'none', px: 0 }} />
      </Tabs>

      <Box role="tabpanel" id="app-settings-panel" aria-labelledby="app-settings-tab" hidden={activeTab !== 0}>
        {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 640px) minmax(280px, 360px)' }, gap: 3, alignItems: 'start' }}>
          <SettingsForm onSave={handleSave} onError={handleError} />
          <OpenAIConnectionTest />
        </Box>
      </Box>

      <Box role="tabpanel" id="feature-flags-panel" aria-labelledby="feature-flags-tab" hidden={activeTab !== 1}>
        <FeatureFlagsForm />
      </Box>
    </Box>
  )
}
